import { publicPost, put, get, getRefreshToken, putAccessToken, putRefreshToken } from './_httpClient';

export async function register({ fullname, email, password }) {
  return publicPost('/clp/users', { fullname, email, password });
}

export async function forgetPassword({ payload }) {
  return publicPost('/users/forget-password', payload);
}

// Beda dari forgetPassword (publik, tanpa login) — ini untuk user yang
// sudah login mengganti password sendiri, wajib mengisi password lama.
export async function changePassword({ oldPassword, newPassword }) {
  const { status, message } = await put('/users/change-password', { oldPassword, newPassword });
  if (status !== 'success') {
    throw new Error(message);
  }
}

export async function login({ email, password }) {
  const responseJson = await publicPost('/authentications', { email, password });
  const { status, message, data } = responseJson;
  return { status, message, data };
}

export async function loginAsEmpBcf({ email, password }) {
  const responseJson = await publicPost('/authentications-bcf', { email, password });
  const { status, message, data } = responseJson;
  return { status, message, data };
}

export async function loginAsMentors({ email, password }) {
  const responseJson = await publicPost('/authentications/clp/mentors', { email, password });
  const { status, message, data } = responseJson;
  return { status, message, data };
}

export async function refreshToken() {
  const responseJson = await put('/authentications', {
    refreshToken: `${getRefreshToken()}`,
  });
  const { status, message, data } = responseJson;

  if (status !== 'success') {
    throw new Error(message);
  }
  putAccessToken(data.accessToken);
}

export async function getSessionContext() {
  const { status, message, data } = await get('/authentications/session');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function switchBatchContext({ batchId }) {
  const responseJson = await put('/authentications/switch', {
    refreshToken: `${getRefreshToken()}`,
    batchId: parseInt(batchId, 10),
  });
  const { status, message, data } = responseJson;

  if (status !== 'success') {
    throw new Error(message);
  }
  putAccessToken(data.accessToken);
  putRefreshToken(data.refreshToken);
  return data;
}
